import React from 'react';


const Footer = () => {
  return (
    <footer>
      <h4>Developed by Aman Prajapati</h4>
      <h4>Copyright &copy; 2023 AP</h4>
    
    </footer>
  )
}

export default Footer